import { Bell } from "lucide-react";

export const NotificationButton = ({ unreadCount = 0 }) => {
  const groupId = localStorage.getItem("groupId");

  return (
    <div className="relative">
      <button className="relative p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors text-slate-500">
        <Bell size={20} />

        {/* 🔴 Count badge from poller */}
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 text-[10px] bg-red-500 text-white px-1 rounded-full">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};